import React from 'react';
import { Modal as ReactstrapModal } from 'reactstrap';
import cn from 'classnames';
import styles from './index.module.scss';

import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter, { ModalActionsPortal } from './ModalFooter';
import { ModalProvider } from './context.js';

export const DEFAULT_CONFIRM_FUNCTION = () => {};

/**
 * @param {Object} props
 * @param {'sm' | 'md' | 'lg' | 'xl'} props.size
 * @param {React.CSSProperties} props.style
 * @param {boolean} props.isOpen
 * @param {boolean} props.centered
 * @param {"static"} props.backdrop
 * @param {boolean} props.isProcessing
 * @param {number} props.zIndex
 * @param {function} props.onEnter
 * @param {function} props.onExit
 * @param {function} props.onOpened
 * @param {function} props.onClose
 * @param {function} props.onClosed
 * @param {string} props.className
 * @param {string} props.wrapClassName
 * @param {string} props.modalClassName
 * @param {string} props.backdropClassName
 * @param {string} props.contentClassName
 * @param {React.ReactNode} props.children
 */
export default function Modal({
  size = 'sm',
  style = {},
  isOpen = false,
  centered = false,
  backdrop = undefined,
  isDisabled = false,
  isProcessing = false,
  zIndex = 10000,
  onEnter = () => {},
  onExit = () => {},
  onOpened = () => {},
  onClose = () => {},
  onClosed = () => {},
  className = '',
  wrapClassName = '',
  modalClassName = '',
  backdropClassName = '',
  contentClassName = '',
  children = null,
  ...reactstrapModalProps
}) {
  const onCloseModal = () => !isProcessing && onClose();

  return (
    <ModalProvider
      onClose={onCloseModal}
      isDisabled={isDisabled}
      isProcessing={isProcessing}
    >
      <ReactstrapModal
        data-ignore-root-focus // This is required for SS-UI to enable input's focus
        isOpen={isOpen}
        centered={centered}
        toggle={onCloseModal}
        onEnter={onEnter}
        onOpened={onOpened}
        onClosed={onClosed}
        onExit={onExit}
        zIndex={zIndex}
        backdrop={backdrop}
        wrapClassName={cn(styles.container, wrapClassName)}
        modalClassName={cn(styles.modal, modalClassName)}
        className={cn(styles.dialog, styles[size], className)}
        contentClassName={cn(styles.content, contentClassName)}
        backdropClassName={cn(styles.backdrop, backdropClassName)}
        style={style}
        {...reactstrapModalProps}
      >
        {children}
      </ReactstrapModal>
    </ModalProvider>
  );
}

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.ActionsPortal = ModalActionsPortal;
